export const AdminPosts = () => {
    return (
        <p>This is the post</p>
    )
}